// src/App.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ContactButton from './components/ContactButton';

// Pages — lazy load ProjectDetails (not needed on initial home page load)
import Home from './pages/Home';
const ProjectDetails = lazy(() => import('./pages/ProjectDetails'));

function App() {
  return (
    <Router>
      <Navbar />
      <ContactButton />
      <main>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectDetails />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </Router>
  );
}

export default App;